import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// import AOS from 'aos';
import './style.css';
import Button from '../../../../ui-core/Button/Button';
import { addAosAnimateClassObserver } from '../../../../utils/helpers';

export const VideoSection = ({ isLoading, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick('I&lsquo;M ready', 'isSignup', 'Video Section');
    }
  };
  const elementRef = useRef();
  useEffect(() => {
    const element = elementRef.current;

    const observer = addAosAnimateClassObserver();

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);
  return (
    <div
      ref={elementRef}
      className="video-wrapper align-items-center"
      data-aos="fade-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <iframe
        className="video-iframe"
        src="https://www.youtube.com/embed/2dJ1lEE-Itk"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>

      <Button
        type="button"
        isLoading={isLoading}
        disabled={isLoading}
        class="site-btn-stroke mx-auto no-arrow"
        text="I&lsquo;M ready"
        onClick={handleClick}
      />
    </div>
  );
};

VideoSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
